import script from "./OrderDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderDetails.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__